export const getLoading = (store) => store.auth.isLoading;

export const getError = (store) => store.auth.error;
